<div *ngIf="active" class="mat-panel">
	<mat-progress-bar *ngIf="loading" mode="indeterminate" class="p-0"></mat-progress-bar>
	<div class="container">
		<div fxLayout="row" fxLayoutAlign="space-between center" class="primary-text">
			<p>{{ name }}</p>
			<p>{{ formattedCreationDate }}</p>
		</div>
		<div *ngIf="IS_NOT_NULL_OR_UNDEFINED(origin) && IS_NOT_NULL_OR_UNDEFINED(destination)">
			<p class="font-size-12">{{ origin + ' -> ' + destination }}</p>
		</div>

		<quill-editor
			[modules]="{ toolbar: false }"
			placeholder="Start typing to add a note..."
			[formControl]="content"
			style="resize: vertical"
			(onEditorCreated)="onEditorCreated($event)"
			(onContentChanged)="onContentChanged($event)"
			(keydown.enter)="enterPressed($event)"
			(keyup.enter)="enterPressed($event)"
			class="full-width"
		></quill-editor>

		<div *ngIf="showFeedback && accountSettings.IS_FEEDBACK_ENABLED && !isAdmin && !edit">
			<mat-divider class="m-t-1"></mat-divider>

			<div fxLayout="column">
				<div
					fxLayout="row"
					fxLayoutAlign="space-between center"
					*ngFor="let feedback of feedbackQuestionMap | keyvalue"
				>
					<p>{{ feedback.value.formattedName }}</p>

					<ng-rating-bar
						*ngIf="feedback.value.type === feedbackType.Rating"
						[(value)]="feedbackQuestionMap[feedback.key]['answer']"
						[ratingCount]="5"
					></ng-rating-bar>

					<div
						*ngIf="feedback.value.type === feedbackType.Question"
						fxLayout="row"
						fxLayoutGap="1rem"
					>
						<span
							class="primary-text cursor-pointer"
							[ngClass]="{
								'font-weight-bold text-underline':
									feedbackQuestionMap[feedback.key]['answer'] === true
							}"
							(click)="feedbackQuestionMap[feedback.key]['answer'] = true"
							>Yes</span
						>
						<span
							class="primary-text cursor-pointer"
							[ngClass]="{
								'font-weight-bold text-underline':
									feedbackQuestionMap[feedback.key]['answer'] === false
							}"
							(click)="feedbackQuestionMap[feedback.key]['answer'] = false"
							>No</span
						>
					</div>
				</div>
			</div>

			<mat-divider></mat-divider>
		</div>

		<mat-dialog-actions class="m-t-1">
			<div fxFlex="100" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="1rem" fxFlexFill>
				<p
					class="primary-text text-underline cursor-pointer font-size-13"
					(click)="cancelClicked.emit(false)"
				>
					Cancel
				</p>
				<button
					[disabled]="content.value === defaultContent"
					mat-raised-button
					color="primary"
					(click)="edit ? updateNote() : submitNote()"
				>
					{{ 'Save' }}
				</button>
			</div>
		</mat-dialog-actions>
	</div>
</div>

<!-- Unexpanded editable note -->
<div
	*ngIf="!active && edit"
	fxLayout="column"
	class="container mat-panel cursor-pointer"
	(click)="expanded = !expanded"
>
	<div fxLayout="row" fxLayoutAlign="space-between center">
		<p class="primary-text font-size-13">{{ formattedCreationDate }}</p>
		<p class="primary-text font-size-13">{{ name }}</p>
		<div fxLayout="row" fxLayoutAlign="end center">
			<span *ngIf="noteEditAndDeleteEnabled" fxLayoutGap="1rem" fxLayoutAlign="end center">
				<span
					class="primary-text font-size-13 text-underline"
					(click)="editClicked.emit(); $event.stopPropagation()"
					>Edit</span
				>
				<mat-icon class="cursor-pointer" style="color: red" (click)="showDeleteNoteConfirmation()"
					>delete_forever
				</mat-icon>
			</span>
		</div>
	</div>
	<div *ngIf="!!user" class="m-b-1" fxLayout="row" fxLayoutAlign="end center">
		<span class="primary-text font-size-12"
			>Last Edited by: {{ user.firstName }} at {{ formatEditTime() }}</span
		>
	</div>
	<mat-divider></mat-divider>
	<div fxLayout="column" fxLayoutAlign="flex-start">
		<div class="m-t-1 m-b-1">
			<p
				[ngClass]="{ wrap: expanded, truncate: !expanded }"
				class="font-size-14 m-0"
				*ngFor="let line of lines | slice: 0 : (expanded ? lines.length : 1)"
			>
				{{ expanded ? line : lines.length > 1 ? line + '...' : line }}
			</p>
		</div>
	</div>
	<div
		*ngIf="showFeedback && accountSettings.IS_FEEDBACK_ENABLED && !isAdmin && feedback"
		fxLayout="row"
		fxLayoutAlign="space-between center"
	>
		<div
			*ngIf="feedback.rating"
			fxLayout="row"
			fxLayoutAlign="space-between center"
			fxLayoutGap="1rem"
		>
			<span class="font-size-12 primary-text">{{ feedbackQuestionMap.rating.condensedName }}</span>
			<span class="font-size-12 primary-text">{{ feedback.rating }}/5</span>
		</div>
		<div
			*ngIf="feedback.hasCapacity"
			fxLayout="row"
			fxLayoutAlign="space-between center"
			fxLayoutGap="1rem"
		>
			<span class="font-size-12 primary-text">{{
				feedbackQuestionMap.hasCapacity.condensedName
			}}</span>
			<span class="font-size-12 primary-text">{{ feedback.hasCapacity ? 'Yes' : 'No' }}</span>
		</div>
	</div>
</div>
